export default "__VITE_ASSET__FCHj3QqJ__"